import { AxiosResponse } from "axios";
import { MARKETPLACE_PAYMENT_TRANSACTION_ENDPOINTS } from "../constants/apiEndpoints";
import { PagedResponse, StandardParams } from "../types/interfaces";
import { MarketPlacePaymentTransaction } from "../types/interfaces/marketPlace.interfaces";
import { appContextGet } from "./httpCommon/appAxios.service";

export const getMarketPlacePaymentTransaction = (
    params?: StandardParams
): Promise<AxiosResponse<MarketPlacePaymentTransaction[] | PagedResponse<MarketPlacePaymentTransaction>>> => 
    appContextGet(MARKETPLACE_PAYMENT_TRANSACTION_ENDPOINTS.BASE, params);